export const countries = [
  {
    name: 'AUD',
    country: 'Австралія',
    currency: 'долар',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Flag_of_Australia_%28converted%29.svg/30px-Flag_of_Australia_%28converted%29.svg.png',
  },
  {
    name: 'AZN',
    country: 'Азербайджан',
    currency: 'манат',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Flag_of_Azerbaijan.svg/30px-Flag_of_Azerbaijan.svg.png',
  },
  // {
  //   name: 'BYN',
  //   country: 'Білорусь',
  //   currency: 'рубль',
  //   url:
  //     'https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Flag_of_Belarus.svg/30px-Flag_of_Belarus.svg.png',
  // },
  {
    name: 'BGN',
    country: 'Болгарія',
    currency: 'лев',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Flag_of_Bulgaria.svg/30px-Flag_of_Bulgaria.svg.png',
  },
  // {
  //   name: 'BRL',
  //   country: 'Бразилія',
  //   currency: 'реал',
  //   url:
  //     'https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Flag_of_Brazil.svg/29px-Flag_of_Brazil.svg.png',
  // },
  {
    name: 'GBP',
    country: 'В.Британія',
    currency: 'фунт',
    url:
      'https://upload.wikimedia.org/wikipedia/en/thumb/a/ae/Flag_of_the_United_Kingdom.svg/320px-Flag_of_the_United_Kingdom.svg.png',
  },
  {
    name: 'GEL',
    country: 'Грузія',
    currency: 'ларі',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Flag_of_Georgia.svg/30px-Flag_of_Georgia.svg.png',
  },
  {
    name: 'DKK',
    country: 'Данія',
    currency: 'крона',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/9/9c/Flag_of_Denmark.svg',
  },
  {
    name: 'EGP',
    country: 'Єгипет',
    currency: 'фунт',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Flag_of_Egypt.svg/30px-Flag_of_Egypt.svg.png',
  },
  {
    name: 'ILS',
    country: 'Ізраїль',
    currency: 'шекель',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Flag_of_Israel.svg/28px-Flag_of_Israel.svg.png',
  },
  {
    name: 'KZT',
    country: 'Казахстан',
    currency: 'теньге',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Flag_of_Kazakhstan.svg/30px-Flag_of_Kazakhstan.svg.png',
  },
  {
    name: 'CAD',
    country: 'Канада',
    currency: 'долар',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Canada_%28Pantone%29.svg/30px-Flag_of_Canada_%28Pantone%29.svg.png',
  },
  {
    name: 'CNY',
    country: 'Китай',
    currency: 'юань',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Flag_of_the_People%27s_Republic_of_China.svg/30px-Flag_of_the_People%27s_Republic_of_China.svg.png',
  },
  {
    name: 'MXN',
    country: 'Мексика',
    currency: 'песо',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Flag_of_Mexico.svg/30px-Flag_of_Mexico.svg.png',
  },
  {
    name: 'MDL',
    country: 'Молдова',
    currency: 'лей',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Flag_of_Moldova.svg/30px-Flag_of_Moldova.svg.png',
  },
  {
    name: 'PLN',
    country: 'Польща',
    currency: 'злотий',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Flag_of_Poland.svg/30px-Flag_of_Poland.svg.png',
  },
  {
    name: 'RON',
    country: 'Румунія',
    currency: 'лей',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Flag_of_Romania.svg/30px-Flag_of_Romania.svg.png',
  },
  {
    name: 'SGD',
    country: 'Сінгапур',
    currency: 'долар',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Flag_of_Singapore.svg/30px-Flag_of_Singapore.svg.png',
  },
  {
    name: 'TRY',
    country: 'Туреччина',
    currency: 'ліра',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Flag_of_Turkey.svg/30px-Flag_of_Turkey.svg.png',
  },
  // {
  //   name: 'TMT',
  //   country: 'Туркменістан',
  //   currency: 'манат',
  //   url:
  //     'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Flag_of_Turkmenistan.svg/30px-Flag_of_Turkmenistan.svg.png',
  // },
  {
    name: 'HUF',
    country: 'Угорщина',
    currency: 'форинт',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Flag_of_Hungary.svg/30px-Flag_of_Hungary.svg.png',
  },
  // {
  //   name: 'UZS',
  //   country: 'Узбекистан',
  //   currency: 'сум',
  //   url:
  //     'https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Flag_of_Uzbekistan.svg/30px-Flag_of_Uzbekistan.svg.png',
  // },
  {
    name: 'CHF',
    country: 'Швейцарія',
    currency: 'франк',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Flag_of_Switzerland.svg/20px-Flag_of_Switzerland.svg.png',
  },
  {
    name: 'CZK',
    country: 'Чехія',
    currency: 'крона',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Flag_of_the_Czech_Republic.svg/30px-Flag_of_the_Czech_Republic.svg.png',
  },
  {
    name: 'JPY',
    country: 'Японія',
    currency: 'єна',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Flag_of_Japan.svg/30px-Flag_of_Japan.svg.png',
  },
];

export const metals = [
  {
    name: 'XAG',
    uk: 'срібло',
    en: 'Ag',
    color: 'silver',
    // number: 47,
    // mass: 107.87,
  },
  {
    name: 'XAU',
    uk: 'золото',
    color: 'gold',
    en: 'Au',
    // number: 79,
    // mass: 196.97,
  },
  {
    name: 'XPT',
    uk: 'платина',
    color: 'platinum',
    en: 'Pt',
    // number: 78,
    // mass: 195.08,
  },
];
